<template>
    <Button class="logout-button" type="button" icon="pi pi-sign-in" :label="$t('topBar.login')" @click="$router.push('/')" />

</template>

<script setup lang="ts">
import { ref } from 'vue'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import { AuthApi } from '@/api/auth/auth'


const open = ref(false)
const busy = ref(false)

</script>


<style scoped>
.logout-confirm-button {
    background-color: transparent;
    border: 1px solid var(--ghm-primary);
    color: var(--ghm-primary);
}

.logout-cancle-button {
    background-color: transparent !important;
    border: 1px solid var(--gray) !important;
    color: var(--gray) !important;
}

.logout-cancle-button:hover {
    background-color: var(--gray) !important;
    border: 1px solid var(--gray) !important;
    color: var(--white) !important;
}

.logout-cancle-button:active {
    background-color: var(--gray) !important;
    border: 1px solid var(--gray) !important;
    color: var(--white) !important;
}

.logout-button {
    background-color: transparent;
    border: 1px solid var(--ghm-primary);
    color: var(--ghm-primary);
}

.logout-button:active {
    background-color: var(--ghm-primary) !important;
    border: 1px solid var(--ghm-primary) !important;
}

.logout-confirm-button:active {
    background-color: var(--ghm-primary) !important;
    border: 1px solid var(--ghm-primary) !important;
}


.logout-button:focus-visible {
    outline: none;
}

.p-dialog-footer {
    justify-content: space-around !important;
}
</style>